import { ReactElement } from 'react'
import { CriteriaConfigurationProject } from 'src/screens/shared/configuration/criteria/CriteriaConfigurationProject'
import { PROJECT } from 'src/shared/constants/constants'

export const CriteriaConfigurationPfKapPage = (): ReactElement => {
  return <CriteriaConfigurationProject projectType={PROJECT.PF_KAP} />
}
